// TODO: Move to checkout-utils
export enum HttpHeader {
  ContentType = 'Content-Type',
  Placement = 'x-placement',
}
